import axios from "../Common/AxiosPayment";

// Wrapper Functions
export function getPaymentWrapper(url) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(url);
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}

export function postPaymentWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(url, data);
      return resolve(res.data);
    } catch (e) {
      console.log(e.message)
      return reject(e);
    }
  });
}

export function putPaymentWrapper(url, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(url, data);
      return resolve(res.data);
    } catch (e) {
      return reject(e);
    }
  });
}
